import { FormattedMessage } from 'react-intl';
import React from 'react';
import differenceInYears from 'date-fns/differenceInYears';
import BigPicture from '../components/Pictures/BigPicture';
import ButtonLink from '../components/UI/ButtonLink';
import LeftColor from '../components/UI/LeftColor';
import MobilePicture from '../components/Pictures/MobilePicture';
import Options from '../components/Menu/Options';
import Paragraph from '../components/UI/Paragraph';
import Title from '../components/UI/Title';
import style from './Home.module.css';
import { renderStrong } from '../services/renderValues';

function Home() {
  const age = differenceInYears(new Date(), new Date(1991, 7, 6));

  return (
    <section className={`${style.home} container-fluid mobile-container`}>
      <div className={`${style.homeDetailsContainer} row align-items-center`}>
        <LeftColor />
        <BigPicture />

        <div
          className={`${style.homeDetails} col-12 col-lg-9 offset-lg-3 text-sm-center text-lg-left`}
        >
          <main>
            <MobilePicture />

            <Title level={1} css="text-uppercase">
              Gautier Labarre
              <span className={`ft-wt-600 ${style.age}`}>
                <FormattedMessage id="age" values={{ age }} />
              </span>
            </Title>
            <Title
              level={2}
              css={`
                ${style.subtitle} text-uppercase
              `}
            >
              <FormattedMessage id="home.title" />
            </Title>

            <Paragraph
              justify
              translationId="home.presentation-1"
              translationValues={{
                strong: renderStrong,
              }}
            />

            <Paragraph
              justify
              translationId="home.presentation-2"
              translationValues={{
                strong: renderStrong,
              }}
            />

            <ButtonLink link="/about" icon="btnAbout">
              <FormattedMessage
                id="home.more-about-me"
                defaultMessage="Plus sur moi"
              />
            </ButtonLink>
          </main>
        </div>
      </div>
      <Options />
    </section>
  );
}

export default Home;
